import { z } from 'zod';
import { webFormFieldConfigSchema } from '../web-forms/fields.js';
import { publicBrandingResponseSchema } from './branding.js';
import { publicCaptureLeadSchema } from './lead-capture.js';
/** No session — the standalone `/forms/:publicKey` page and the
 * `/embed/forms/:publicKey` iframe variant both render themselves entirely
 * from this, so a form's look/fields/copy can change without a frontend
 * deploy. */
export const publicWebFormConfigResponseSchema = z.object({
    name: z.string(),
    fields: z.array(webFormFieldConfigSchema),
    successHeadline: z.string(),
    successMessage: z.string(),
    redirectUrl: z.string().nullable(),
    branding: publicBrandingResponseSchema,
});
export const publicWebFormSubmitSchema = publicCaptureLeadSchema;
export const publicWebFormSubmitResponseSchema = z.object({ leadId: z.string().uuid() });
//# sourceMappingURL=web-forms.js.map